class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.cartCounts = document.querySelectorAll('.icon-bubble-count');
    this.openCart = document.querySelector('[data-action="open-drawer"]');
    this.closeButtons = this.querySelectorAll('[data-close-cart-drawer]');
    this.cartItems = this.querySelector('.cart-drawer__items');
    this.cartFooter = this.querySelector('.cart-drawer__footer-content');
    this.cartBubbles = document.querySelectorAll('.cart-icon-bubble');

    this.openCart.addEventListener('click', (e) => {
      e.preventDefault();
      this.loadContent();
      this.open();
    });
    this.closeButtons.forEach((btn) => {
      btn.addEventListener('click', this.close.bind(this));
    });
    document.addEventListener('close::cart-drawer', this.close.bind(this));
    this.addEventListener('click', function (e) {
      const cartDrawerInner = this.querySelector('.cart-drawer-inner');

      if (!cartDrawerInner.contains(e.target)) {
        this.close.bind(this)();
      }
    });
  }

  loadContent(open, onOpen) {
    fetch('/cart')
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const cartItems = html.querySelector('[data-cart-items]');
        const cartFooter = html.querySelector('[data-cart-footer]');
        const cartBuble = html.querySelector('.cart-count-bubble-value');
        const newCartLength = document.querySelectorAll('.cart-count-bubble-value');      
  

        if (this.cartItems && cartItems) {
          this.cartItems.innerHTML = cartItems.innerHTML;           
        }
      
        if (this.cartFooter && cartFooter) {
          this.cartFooter.innerHTML = cartFooter.innerHTML;
        }
        if (this.cartBubbles && cartBuble) {
          this.cartBubbles.forEach((item) => {
            item.innerHTML = cartBuble.innerHTML?.trim();
          });
          newCartLength.forEach((i) => {
            i.innerHTML = cartBuble.innerHTML?.trim();
            if (Number(cartBuble.innerHTML) > 0) {
              i.classList.add('show');
            } else {
              i.classList.remove('show');
            }
          });
        }

        if (open) {
          this.open.bind(this)();
          onOpen?.();
        }

        document.body.dispatchEvent(new Event("initTheWishlist"));
        
      });
  }

  open() {
    this.classList.add('displayed');
    document.body.classList.add('cart-drawer-displayed');
  }

  close() {
    this.classList.remove('displayed');
    document.body.classList.remove('cart-drawer-displayed');
    document.getElementById('boost-sd__modal-card')?.click();
  }
}

customElements.define('cart-drawer', CartDrawer);
